/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const MobileNotificationIcon = ({
  className,
  style: styleFromProps,
  color = '#938BB7',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10131_130318)">
        <path
          d="M7.49603 5.69446H2.26097C1.35793 5.69446 0.625031 6.38738 0.625031 7.24117V17.7589C0.625031 18.6126 1.35793 19.3056 2.26097 19.3056H7.49603C8.39908 19.3056 9.13198 18.6126 9.13198 17.7589V7.24117C9.13198 6.38738 8.39908 5.69446 7.49603 5.69446ZM4.87852 17.8362C4.33537 17.8362 3.89695 17.4217 3.89695 16.9082C3.89695 16.3946 4.33537 15.9801 4.87852 15.9801C5.42166 15.9801 5.86009 16.3946 5.86009 16.9082C5.86009 17.4217 5.42163 17.8362 4.87852 17.8362Z"
          fill="url(#paint0_linear_10131_130318)"
        />
        <path
          d="M7.49603 5.69446H2.26097C1.35793 5.69446 0.625031 6.38738 0.625031 7.24117V17.7589C0.625031 18.6126 1.35793 19.3056 2.26097 19.3056H7.49603C8.39908 19.3056 9.13198 18.6126 9.13198 17.7589V7.24117C9.13198 6.38738 8.39908 5.69446 7.49603 5.69446ZM4.87852 17.8362C4.33537 17.8362 3.89695 17.4217 3.89695 16.9082C3.89695 16.3946 4.33537 15.9801 4.87852 15.9801C5.42166 15.9801 5.86009 16.3946 5.86009 16.9082C5.86009 17.4217 5.42163 17.8362 4.87852 17.8362Z"
          fill="url(#paint1_linear_10131_130318)"
        />
        <g filter="url(#filter0_d_10131_130318)">
          <path
            d="M6.90274 0C6.13757 0 5.00003 1.13754 5.00003 1.90271V10.4372C5.00003 10.5904 5.07605 10.7337 5.20294 10.8196C5.32984 10.9055 5.49109 10.9229 5.63337 10.866L7.77733 9.49114C7.83188 9.46934 7.89009 9.45812 7.94885 9.45812H18.0973C18.8625 9.45812 20 8.32061 20 7.55541V1.90271C20 1.13754 18.8625 0 18.0973 0H6.90274Z"
            fill="#2F54EB"
          />
        </g>
        <circle cx="9.48269" cy="4.82782" r="1.03448" fill="white" />
        <circle cx="12.9309" cy="4.82782" r="1.03448" fill="white" />
        <circle cx="16.3794" cy="4.82782" r="1.03448" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_d_10131_130318"
          x="3.03574"
          y="-0.982143"
          width="18.9286"
          height="14.8276"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.982143" />
          <feGaussianBlur stdDeviation="0.982143" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.439333 0 0 0 0 0.666667 0 0 0 0 0.15 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10131_130318"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10131_130318"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10131_130318"
          x1="9.30171"
          y1="5.81947"
          x2="-3.06332"
          y2="13.5491"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10131_130318"
          x1="9.11307"
          y1="5.7247"
          x2="-3.06726"
          y2="13.3374"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.119792" stopColor="#222222" />
          <stop offset="1" stopColor="#688FA5" />
        </linearGradient>
        <clipPath id="clip0_10131_130318">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
